"use strict";

const { String } = require("../lib/types");

const karnofskyPalliativePerformance = "Karnofsky Palliative Performance Scale";

module.exports = {
  karnofskyPalliativePerformance: {
    name: "karnofskyPalliativePerformance",
    question: karnofskyPalliativePerformance,
    fhirType: String,
    jq: ["item[text=?].answer[0].valueString", karnofskyPalliativePerformance]
  }
};
